function toggleNearForm(form, id, show) {
  if (!id || !form) return;
  const root = form.parentElement || document;
  const el = root.querySelector('#' + id);
  if (!el) return;

  el.classList.toggle('is-hidden', !show);
}
  
document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.js_form');
  if (!forms.length) return;

  forms.forEach(form => {
    const submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;

    const {
      successId,
      errorId,
      downloadUrl,
      formname: formName,
      conversion: conversionID
    } = form.dataset;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      const turnstileWidget = form.querySelector('.cf-turnstile');
      const requiresTurnstile = !!turnstileWidget;

      if (requiresTurnstile) {
        const tokenField = form.querySelector('[name="cf-turnstile-response"]');
        if (!tokenField || !tokenField.value.trim()) {
          alert('Please complete the CAPTCHA verification.');
          return;
        }
      }
      const data = new FormData(form);

      const originalText =
        'textContent' in submitBtn
          ? submitBtn.textContent
          : submitBtn.value || 'Send';

      submitBtn.disabled = true;
      if ('textContent' in submitBtn) submitBtn.textContent = 'Sending...';
      else submitBtn.value = 'Sending...';

      toggleNearForm(form, errorId, false);

      try {
        const response = await fetch(form.action, {
          method: form.method,
          headers: {
            'accept': 'application/json'
          },
          body: data
        });

        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }

        if (formName) {
          plausible('Form Submission', {
            props: {
              form_name: formName
            }
          });
        }

        if (typeof gtag === 'function') {
          if (formName) {
            gtag('event', 'generate_lead', {
              page_location: location.href,
              transport_type: 'beacon',
              form_name: formName
            });
          }
          if (conversionID) {
            gtag('event', 'conversion', {
              send_to: conversionID,
              transport_type: 'beacon',
              'value': 1.0,
              'currency': 'USD'
            });
          }
        }

        if (typeof fbq === 'function') {
          if (formName) {
            fbq('track', 'Lead', {
              form_name: formName
            });
          }
        }

        form.classList.add('is-hidden');
        toggleNearForm(form, successId, true);

        form.reset();
        if (requiresTurnstile && typeof turnstile !== 'undefined') {
          try {
            turnstile.reset(turnstileWidget);
          } catch (e) {
            /* no-op */
          }
        }

        if ('textContent' in submitBtn) submitBtn.textContent = 'Sent!';
        else submitBtn.value = 'Sent!';

        if (downloadUrl) {
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = '';
          a.target = '_blank';
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

      } catch (err) {
        console.error('Submission error:', err);

        toggleNearForm(form, errorId, true);

        submitBtn.disabled = false;
        if ('textContent' in submitBtn) submitBtn.textContent = originalText;
        else submitBtn.value = originalText;
      }
    });
  });
});